import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('farmNameField');

    return {
        FARM_NAME_FIELD_LABEL: t('farmNameFieldLabel')
    };
};

export default useTranslation;
